/**
 * Picks the singular or plural noun for a count.
 *
 * Only 1 takes the singular form — 0 and everything above 1 are plural
 * ("0 Campaigns", "1 Campaign", "2 Campaigns").
 *
 * Defaults to the regular `-s` plural; pass `plural` for irregular nouns.
 */
export function $pluralize(
  count: number,
  singular: string,
  plural = `${singular}s`,
): string {
  return count === 1 ? singular : plural;
}

/** The same rule, prefixed with the count itself — e.g. `"1 Lobbyist"`. */
export function $pluralizeWithCount(
  count: number,
  singular: string,
  plural?: string,
): string {
  return `${count} ${$pluralize(count, singular, plural)}`;
}
